<!--  -->
<template>
  <div class="we-view">
    <vue-ueditor-wrap
      v-model="content"
      @ready="ready"
      :config="myConfig"
      :destroy="true"
    />
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  data() {
    return {
      content: "",
      editorInstance: {},
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 380,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // 上传文件接口（这个地址不用管）
        serverUrl: "",
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "/UEditor/",
        zIndex: 9999,
        toolbars: [
          [
            "undo", //撤销
            "bold", //加粗
            "forecolor", //字体颜色
            "justifyleft", //居左对齐
            "justifyright", //居右对齐
            "justifycenter", //居中对齐
            "justifyjustify", //两端对齐
            "rowspacingtop", //段前距
          ],
        ],
        fontfamily: 'FangSong_GB2312',
        fontsize: '17',
        lineheight: '2',
      },
    };
  },
  props: ["detail"],
  components: {
    VueUeditorWrap,
  },
  watch: {
    content(val) {
      this.$emit("change-con", val);
    },
    detail(val) {
      this.content = val;
    },
  },

  computed: {},

  mounted() {},

  methods: {
    ready(editorInstance) {
      this.editorInstance = editorInstance;
      this.content = this.detail;
    },
  },
};
</script>
<style lang="scss" scoped>
.we-view {
  padding: 5px 0;
  z-index: 888;
}
  // 隐藏图片上传的按钮
  /deep/ .edui-for-dialog-button {
    display:none !important;
  }
</style>
